import { services } from '@/mocks/services';
import SectionShell from '@/components/feature/SectionShell';
import SectionHeader from '@/components/feature/SectionHeader';
import { ArmedGroup, moDelay } from '@/lib/motion/Reveal';

export function RatesSection() {
  return (
    <SectionShell id="pricing" labelledBy="pricing-title">
      <SectionHeader index="06" name="Rates" titleId="pricing-title" title="Starting rates" meta="Quotes shaped by usage, crew and timeline" />
      <ArmedGroup as="ul" className="flex flex-col gap-5 border-t border-background-200 pt-8 md:gap-6">
        {services.map((s, i) => (
          <li key={s.id} className="mo-aitem mo--rate grid grid-cols-12 items-baseline gap-4" style={moDelay(0, i, 55)}>
            <span className="col-span-2 font-label text-[11px] font-medium tracking-[0.12em] text-foreground-500 md:col-span-1">{s.index}</span>
            <span className="col-span-6 text-[15px] font-medium text-foreground-950 md:col-span-8 md:text-[17px]">{s.name}</span>
            <span className="col-span-4 whitespace-nowrap text-right text-[15px] tabular-nums text-foreground-700 md:col-span-3 md:text-[17px]">{s.price}</span>
          </li>
        ))}
      </ArmedGroup>
    </SectionShell>
  );
}

export default function ServicesSection() {
  return (
    <SectionShell id="services" labelledBy="services-title">
      <SectionHeader index="04" name="Services" titleId="services-title" title="What I shoot" meta={`${services.length} disciplines`} />
      <ArmedGroup as="ol" className="flex flex-col gap-8 md:gap-10">
        {services.map((s, i) => (
          <li key={s.id} className="mo-aitem mo--row grid grid-cols-1 gap-2 md:grid-cols-12 md:items-baseline md:gap-4" style={moDelay(0, i, 70)}>
            <span className="font-heading text-2xl font-normal tracking-[-0.02em] text-foreground-500 md:col-span-1 md:text-[28px]">{s.index}</span>
            <h3 className="font-heading text-xl font-medium tracking-[-0.015em] text-foreground-950 md:col-span-5 md:text-[24px]">{s.name}</h3>
            <p className="text-sm leading-relaxed text-foreground-700 md:col-span-6 md:text-[15px]">{s.description}</p>
          </li>
        ))}
      </ArmedGroup>
    </SectionShell>
  );
}